module.exports = __webpack_public_path__ + "media/images/home-page/3-3@2x-da30788ecd40d16f6e9e386cff67b2ae.png";